import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOfferPlans } from '../../reducers/promotions';
import { parsePromotionPricingConfig } from '../../helpers/common';
import { KeyValue } from '../../types/common.types';

export const usePromotionPricing = (
  promotionPricingConfig: string | undefined,
  offerMode: string | undefined
) => {
  const dispatch = useDispatch();
  const { promotions } = useSelector((state: KeyValue) => {
    return {
      promotions: state.promotions
    };
  });

  useEffect(() => {
    // URL param takes preference: only short-circuit if a promotion is already
    // loaded AND it matches the offerMode coming in from the URL.
    if (
      promotions?.activePromotion &&
      promotions?.promotionLoaded &&
      promotions?.offerMode === offerMode
    ) {
      return;
    }

    if (offerMode && promotionPricingConfig) {
      const result = parsePromotionPricingConfig(
        offerMode,
        promotionPricingConfig
      );
      if (result) {
        dispatch(
          setOfferPlans(offerMode, result.pricingMap, result.transactionOptions)
        );
      } else {
        dispatch(setOfferPlans(null, null, null));
      }
    } else {
      dispatch(setOfferPlans(null, null, null));
    }
  }, [
    offerMode,
    promotionPricingConfig,
    promotions?.activePromotion,
    promotions?.promotionLoaded,
    promotions?.offerMode,
    dispatch
  ]);
};
